import React from 'react';
import PropTypes from 'prop-types';
import { projectType } from 'types';

// eslint-disable-next-line import/no-named-as-default
import SidebarMenuItem from './components/SidebarMenuItem';
import '../../style.scss';

/* eslint-disable react/no-array-index-key, react/no-typos */
const SidebarMenu = ({ isOpen, menuItems, currentProject }) => (
  <div styleName="sidebar__menu">
    {menuItems.map((item, index) => (
      <SidebarMenuItem
        key={index}
        currentProject={currentProject}
        item={item}
        isOpen={isOpen}
      />
    ))}
  </div>
);

SidebarMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentProject: projectType.isRequired,
};

export default SidebarMenu;
